const getDefaultState = () => {
  return {
    windowData: {},
    isSave: true,
    showDetailNotice: true,
    showDateTips: true,
    showUploadTips: true,
    allBtnReturnRouter: 'fileManage',
    fullBoxScreen: false
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_WINDOWDATA: (state, windowData) => {
    state.windowData = windowData
  },
  SET_IS_SAVE: (state, isSave) => {
    state.isSave = isSave
  },
  SET_SHOW_DETAIL_NOTICE: (state, showDetailNotice) => {
    state.showDetailNotice = showDetailNotice
  },
  SET_SHOW_DATE_TIPS: (state, showDateTips) => {
    state.showDateTips = showDateTips
  },
  SET_SHOW_UPLOAD_TIPS: (state, showUploadTips) => {
    state.showUploadTips = showUploadTips
  },
  SET_ALL_BTN_RETURN_ROUTER: (state, allBtnReturnRouter) => {
    state.allBtnReturnRouter = allBtnReturnRouter || 'fileManage'
  },
  SET_FULL_BOX_SCREEN: (state, fullBoxScreen) => {
    state.fullBoxScreen = fullBoxScreen
  },
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

